import {
    AssistantSuggestion,
    AssistantSuggestionEntityType,
    AssistantSuggestionType,
} from '@mews-commander/data-access';
import { KeywordColor } from './extentedTextInput/KeywordColor';
import { MqlTriggerCharacter, MqlWordSeparator } from './Mql';

export const containsKeyword = (input: string | undefined, keywordColorArray: KeywordColor[]): boolean =>
    keywordColorArray.some((keywordColor) => input?.includes(keywordColor.keyword));

export const startsWithMqlTriggerCharacter = (input: string | undefined): boolean =>
    input?.startsWith(MqlTriggerCharacter) ?? false;

export const removeMqlTriggerCharacter = (input: string | undefined): string | undefined =>
    startsWithMqlTriggerCharacter(input) ? input?.replace(MqlTriggerCharacter, '') : input;

export const getIsMql = (input: string | undefined, _keywordColorArray: KeywordColor[] | undefined): boolean => {
    const isMql = false;
    const inputStartWithSlash = startsWithMqlTriggerCharacter(input);
    if (inputStartWithSlash) {
        return true;
    }

    // This code below will most probably be activated as there is a discussion on how to trigger the MQL mode.
    /* input?.split(MQL.wordSeparator).map((word, index) => {
        const foundKeyword = keywordColorArray?.find((item) => item.keyword.toLowerCase() === word.toLowerCase());

        if (foundKeyword && index === 0 && foundKeyword.isCommand) {
            isMql = true;
        } else if (index === (input?.length ?? 0) - 1 && !isMql) {
            isMql = false;
        }
    }); */

    return isMql;
};

export const mergeText = (text: string, keyword: string): string => {
    const words = text.split(MqlWordSeparator);
    const lastWord = words[words.length - 1];
    if (text.trimEnd() === MqlTriggerCharacter) {
        return `${text}${keyword}`;
    }
    if (keywordContainsAndStartWithText(keyword, lastWord)) {
        const lastWordNoMqlTriggerCharacter = lastWord.replace(MqlTriggerCharacter, '');
        return text.replace(lastWordNoMqlTriggerCharacter, keyword);
    }

    return `${text.trimEnd()}${MqlWordSeparator}${keyword}`;
};

const keywordContainsAndStartWithText = (keyword: string, text: string): boolean => {
    const keywordLower = keyword.toLowerCase();
    const textLowerNoMqlTriggerCharacter = text.toLowerCase().replace(MqlTriggerCharacter, '');

    const keywordContainsText =
        textLowerNoMqlTriggerCharacter.length > 0 ? keywordLower.includes(textLowerNoMqlTriggerCharacter) : false;

    return keywordContainsText && keywordLower.startsWith(textLowerNoMqlTriggerCharacter);
};

export const transformAutocompleteCasesWithInputCases = (input: string | undefined, autocomplete: string): string => {
    if (!input) {
        return autocomplete;
    }
    let updatedAutocomplete = '';
    for (let i = 0; i < autocomplete.length; i++) {
        if (i >= input.length) {
            updatedAutocomplete += autocomplete[i];
        } else if (input[i]?.toLowerCase() === autocomplete[i].toLowerCase()) {
            updatedAutocomplete += input[i];
        } else {
            updatedAutocomplete += autocomplete[i];
        }
    }
    return updatedAutocomplete;
};

export const convertToMql = (text: string, suggestion: AssistantSuggestion): string => {
    let newText: string = text;
    if (
        suggestion.type === AssistantSuggestionType.Value &&
        (suggestion.entityType === AssistantSuggestionEntityType.Reservation ||
            suggestion.entityType === AssistantSuggestionEntityType.Guest)
    ) {
        newText = text.replace(suggestion.text, `${suggestion.entityType} = ${suggestion.id}`);
    }

    return newText;
};
